import { useLanguage } from '../context/LanguageContext';

const TechStack = () => {
  const { language } = useLanguage();

  const content = {
    es: {
      badge: 'Stack & Ecosistema',
      title: 'Tecnologías Modernas para',
      titleHighlight: 'Escalar Productos',
      subtitle: 'Combinamos los frameworks y modelos de IA más avanzados para crear productos rápidos, seguros y mantenibles.'
    },
    en: {
      badge: 'Tech Ecosystem',
      title: 'Modern Technologies to',
      titleHighlight: 'Scale Products',
      subtitle: 'We combine leading frameworks and AI models to build fast, secure, and maintainable products.'
    }
  };

  const t = content[language];

  const technologies = [
    { name: 'React', category: 'Frontend', color: '#06B6D4' },
    { name: 'Next.js', category: 'Frontend', color: '#0F172A' },
    { name: 'Vue.js', category: 'Frontend', color: '#10B981' },
    { name: 'React Native', category: 'Mobile', color: '#6366F1' },
    { name: 'Flutter', category: 'Mobile', color: '#02569B' },
    { name: 'Node.js', category: 'Backend', color: '#16A34A' },
    { name: 'Python', category: 'Backend', color: '#3776AB' },
    { name: 'FastAPI', category: 'Backend', color: '#009688' },
    { name: 'PostgreSQL', category: 'Database', color: '#336791' },
    { name: 'MongoDB', category: 'Database', color: '#10AA50' },
    { name: 'AWS Cloud', category: 'Cloud', color: '#FF9900' },
    { name: 'Google Cloud', category: 'Cloud', color: '#4285F4' },
    { name: 'Docker', category: 'DevOps', color: '#2496ED' },
    { name: 'OpenAI API', category: 'AI', color: '#10A37F' },
    { name: 'Anthropic Claude', category: 'AI', color: '#D97706' },
  ];

  return (
    <section
      id="tech-stack"
      data-testid="tech-stack-section"
      className="relative py-16 lg:py-20 overflow-hidden bg-white border-t border-slate-100"
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-10">
          <div className="stripe-badge mb-3 inline-flex">
            <span>⚙️</span>
            <span>{t.badge}</span>
          </div>
          <h2 className="font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl mb-3 text-[#0F172A] tracking-tight">
            {t.title}{' '}
            <span className="bg-gradient-to-r from-[#4F46E5] to-[#7C3AED] bg-clip-text text-transparent">
              {t.titleHighlight}
            </span>
          </h2>
          <p className="text-sm lg:text-base text-slate-500 max-w-xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Tech Grid */}
        <div className="flex flex-wrap justify-center gap-2.5 lg:gap-3 max-w-4xl mx-auto">
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="group px-4 py-2 rounded-full bg-slate-50 border border-slate-200/80 hover:border-[#4F46E5]/40 hover:bg-white transition-all shadow-sm"
            >
              <div className="flex items-center gap-2">
                <div
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: tech.color }}
                />
                <span className="text-xs sm:text-sm font-semibold text-slate-700 group-hover:text-[#0F172A] transition-colors">
                  {tech.name}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Categories */}
        <div className="flex flex-wrap justify-center gap-6 mt-8 text-xs text-slate-400 font-semibold uppercase tracking-wider">
          {['Frontend', 'Backend', 'Mobile', 'Cloud', 'DevOps', 'Applied AI'].map((cat, i, arr) => (
            <span key={cat} className="flex items-center gap-3">
              {cat}
              {i < arr.length - 1 && <span className="w-1 h-1 rounded-full bg-slate-300" />}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
